var map = {
	"./absa_icon.png": 24220,
	"./appletree_icon.png": 31819,
	"./aunipay_icon.png": 40560,
	"./awalletPaymentplug_icon.png": 39483,
	"./default_icon.png": 88138,
	"./dreamzwallet_icon.png": 22685,
	"./dreamzwalletz_icon.png": 67279,
	"./onetap_icon.png": 66286,
	"./takapaysa_icon.png": 49408,
	"./transactWorldUK_icon.png": 34737,
	"./unipay_icon.png": 81083
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49520;